import { useContext, useEffect } from "react";
import { getSearchOrder } from "../const";
import { AuthenticatedUser } from "@services/user/types";
import { SearchContext } from "../../context/search";
import { useLocation } from "react-router-dom";

const searchTypeValues = [
  "devices",
  "users",
  "meetings",
  "rooms",
  "locations",
  "tickets",
];
const searchTypeMap: Record<string, SearchType> = {
  devices: "Devices",
  users: "Users",
  meetings: "Meetings",
  tickets: "Tickets",
  locations: "Locations",
  rooms: "Rooms",
};

export const getSearchTypeFromLocation = (): SearchType | undefined => {
  const pathname = location.pathname
    .split("/")
    .find((item) => searchTypeValues.includes(item));

  return pathname ? searchTypeMap[pathname] : undefined;
};

export const useInitializeSearchType = (user?: AuthenticatedUser) => {
  const location = useLocation();
  const context = useContext(SearchContext);

  useEffect(() => {
    const actualSearchTypes = getSearchOrder(user);
    const searchTypeFromLocation = getSearchTypeFromLocation();
    const searchType = searchTypeFromLocation || actualSearchTypes[0];

    if (searchType && actualSearchTypes.includes(searchType)) {
      context.dispatch({ searchType });
    }
  }, [location.pathname, user]);
};
